import instance from "@/utils/require.js"
// ADAS下载记录--分页查询
export function apiAdasRecordSearch(data = {}) {
	return instance({
		url: "aim/api/v3/adas/search",
		method: "post",
		data
	})
}